import ContainerScreenGeneral from "../../components/ContainerScreenGeneral";
import { useGeneralAppStore } from "../../store/generalAppStore";
import ModalPdf from "../../components/Modals/ModalPdf";
import { useRifaStore } from "../../store/rifaStore";


// import "./style.css"

import imgLogo1 from "../../assets/PNG/fdlc_horizontal.png";
import imgLogo2 from "../../assets/PNG/fdlc_vRecurso 3.png";
import Cargando from "../../components/Cargando";
import Loading from "../../components/Loading";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useWindowSize from "../../hooks/useWindowSize";
import imgPago from '../../assets/pago-tic.png'

import './style.css'
import { QRCodeSVG } from "qrcode.react";

export function Pago() {

    const { handlerModal, modals } = useGeneralAppStore();
    const { solicitud } = useRifaStore();

    const nav = useNavigate();

    // useEffect(() => {
    //     if (!solicitud) {
    //         nav('/')
    //     }
    // }, [solicitud])

    const size = useWindowSize();
    const { width } = size;

    // bg={"#C2D9F2"}
    // console.log((width*20)/400)
    console.log(solicitud)

    return (
        <>
            <main className='bg1 pt-4 pb-5' >
                {/* <section className={`d-flex flex-column align-items-center w-100 pb-5 bg-danger ${width < 430 && "pt-4"}`}> */}
                <section className="bordes-container " style={{
                    borderTopRightRadius: "1rem",
                    borderTopLeftRadius: "1rem",
                    borderBottomLeftRadius: "1rem",
                    borderBottomRightRadius: "1rem",
                    width: "fit-content",
                    //  background: width < 320 && 'transparent'
                }}>
                    <img src={imgLogo1} width={"100%"} style={{ maxWidth: width > "1200" ? "400px" : "400px" }} className="mx-auto" />
                    <section className="w-100 d-flex flex-column gap-0    pt-4" style={{
                        // borderRadius:"100% 100% 0 0",
                        borderBottomLeftRadius: "1rem",
                        borderBottomRightRadius: "1rem",
                        backgroundColor: "#FAFAFA",
                        // clipPath:"path('M 0 450 Q 0 0 0 60 Q 250 10 500 60 Q 500 60 500 450 Z')",
                        clipPath: `path('M 0 700 Q 0 0 0 ${width < 400 ? (width * 20) / 400 : "20"} Q ${width < 400 ? width / 2 : "200"}  ${width < 400 ? "-10" : "-20"} ${width < 400 ? width : "400"} ${width < 400 ? (width * 20) / 400 : "20"} Q 400 60 400 700 Z')`,
                        // borderTopRightRadius:"200px",
                        // borderTopLeftRadius:"5rem",
                        // clipPath: "ellipse(90% 90% at 90% 50%)",
                        // clipPath: "path('M0,50 Q100,0 200,50 T300,50 L300,200 L0,100% Z')",
                        // clipPath:"circle(92% at 50% 100%)",
                        maxWidth: "500px"
                        // width <= 320 ? "270px" :
                        //  width <= 430 ? "320px" : width > 1200 && width <= 1440 ? "800px " : width > 1440 ? "900px " : "  650px"
                    }}  >
                        <div className={`d-flex flex-column ${width <= 320 && "flex-column"}   gap-3  pb-3 `} style={{ width: "100%", maxWidth: "900px", }}>
                            {/* <div className="bg-danger" style={{width:"600px", height:"600px"}}> */}
                            {/* <svg width={"500"} height={"700"}>
                                    <circle cx={0} cy={500} r={3} />
                                    <circle cx={0} cy={60} r={3} />
                                    <circle cx={500} cy={60} r={3} />
                                    <circle cx={500} cy={500} r={3} />

                                    <text x="0" y={500} dx={20}>A</text>
                                    <text x="0" y={60} dx={10}>B</text>
                                    <text x="450" y={60} dx={10}>C</text>
                                    <text x="450" y={500} dx={10}>D</text>

                                    <path d="M 0 700 Q 0 0 0 60 Q 250 10 500 60 Q 500 60 500 700 Z"  stroke="blue" fill="none"></path>
                                </svg> */}
                            {/* </div> */}
                            <div className="d-flex flex-column gap-2">
                                <p className="text-center fs-6"
                                    style={{ color: "#6A1BB0" }}
                                >QR DE PAGO</p>

                                {

                                }
                                <div className=" mx-auto p-2" style={{ width: "fit-content", border: "2px solid #6A1BB0", borderRadius: "12px" }}>
                                    <QRCodeSVG
                                        className="mx-auto"
                                        // value={solicitud?.qr_recibo}
                                        value={solicitud?.pagoTic}
                                        title={"Title for my QR Code"}
                                        size={width < 320 ? 120 : 140}
                                        bgColor={"#FFC1E8"}
                                        fgColor={"#6A1BB0"}
                                        level={"L"}
                                        minVersion={7}
                                        imageSettings={{
                                            src: "https://webservice.muninqn.gov.ar/cglobales/assets/icons_fc/logoFC.png",
                                            x: undefined,
                                            y: undefined,
                                            height: width < 320 ? 30 : 40,
                                            width: width < 320 ? 30 : 40,
                                            opacity: 1,
                                            excavate: true,
                                        }}
                                    /></div>
                            </div>
                            <div className="d-flex justify-content-center align-items-center gap-2">
                                <div style={{ border: "1px solid #6A1BB0", width: "50px", height: "1px", }}></div>
                                <h5 style={{ color: "#6A1BB0" }}> o </h5>
                                <div style={{ border: "1px solid #6A1BB0", width: "50px", height: "1px", }}></div>

                            </div>
                            <div className="d-flex flex-column align-items-center gap-4 ">
                                <div className="d-flex flex-column align-items-center gap-2 ">
                                    <p className="text-center fs-6" style={{ color: "#6A1BB0" }} >LINK DE PAGO</p>
                                    {/* <Link to={solicitud?.qr_recibo} className="rounded px-3 py-1 " style={{background:"#198754", color:"#fff"}}>PAGAR</Link> */}
                                    <Link to={solicitud?.pagoTic} className="rounded px-3 py-1 " style={{background:"#198754", color:"#fff"}} target="__blank">PAGAR</Link>
                                    {/* <button style={{ border: "none", boxShadow: "2px 2px 2px 10px" }}>PAGAR</button> */}
                                </div>

                                <div className="w-100  d-flex justify-content-center pt-1">
                                    <img className="mx-auto " style={{ width: "100%", maxWidth: "80px" }} src={imgPago} alt="icono-pago" />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center pt-4  pb-5 " >
                            <button style={{ border: "none", boxShadow: "2px 2px 2px 10px", background: "#FFA000" }} onClick={() => nav('/')}>VOLVER</button>
                        </div>
                    </section>
                </section>
                {/* </section> */}

                {/* <ContainerScreenGeneral size={'md'}
                    bg={"#FBF3FF"}
                >
                    {
                        solicitud &&

                        <div className=" col-11 mx-auto  positiona-relative" >
                            <img src={imgLogo1} width={"75%"} style={{
                                top: "-40px",
                                left: "50%",
                                transform: "translate(-50%, -50%)"
                            }} className="position-absolute" />
                            <div className="w-100 h-100 d-flex justify-content-center flex-column gap-4 align-items-center  " style={{ paddingTop: "100px" }}>
                                <img src={solicitud.qr} alt="" />
                                <a style={{ fontSize: "1.5rem", }} className="text-center" href={solicitud.qr_recibo}>{solicitud.qr_recibo}</a>
                            </div>
                        </div>
                    }
                </ContainerScreenGeneral> */}

                {modals.includes('descarga_pdf')
                    &&
                    <ModalPdf />
                }

            </main>
        </>
    )
}